import { FC } from 'react'
import { Button, Container, PlayIcon, Poster } from './styled'
import { texts } from '../../locale'

type Props = {
  posterSrc: string
  videoId: string
}

export const YoutubeLink: FC<Props> = ({ videoId, posterSrc }) => (
  <Container
    href={`https://www.youtube.com/watch?v=${videoId}`}
    target="_blank"
  >
    <Poster src={posterSrc} alt="" />
    <Button>
      <PlayIcon />
      {texts.watchOnYT}
    </Button>
  </Container>
)
